import type { CrmIntegrationMessageView } from '../types/crm-integration-message.types'

export const sortCrmIntegrationMessagesAsc = (
  items: CrmIntegrationMessageView[],
): CrmIntegrationMessageView[] =>
  [...items].sort((left, right) => {
    const leftTime = new Date(left.createdAt).getTime()
    const rightTime = new Date(right.createdAt).getTime()
    if (leftTime !== rightTime) {
      return leftTime - rightTime
    }
    return left.id - right.id
  })

export const mergeCrmIntegrationMessagesPage = (
  prev: CrmIntegrationMessageView[],
  next: CrmIntegrationMessageView[],
): CrmIntegrationMessageView[] => {
  if (next.length === 0) {
    return prev
  }

  const byId = new Map(prev.map((item) => [item.id, item]))

  for (const item of next) {
    byId.set(item.id, item)
  }

  return sortCrmIntegrationMessagesAsc([...byId.values()])
}

export const hasNewIncomingCrmIntegrationMessages = (
  previous: CrmIntegrationMessageView[],
  next: CrmIntegrationMessageView[],
): boolean => {
  const previousIds = new Set(previous.map((item) => item.id))
  return next.some(
    (item) => item.direction === 'incoming' && !previousIds.has(item.id),
  )
}
